import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { formatDateForMySQL } from "../../../components/formatDate";
// import { API_URL } from "../../../config/constants";
import axios from "axios";

export const SaveAsset = async (asset) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Asset/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(asset),
      });
      
      const data = await response.json();       
      // console.log(asset)
      // console.log(data)
      
      if (response.ok && !data.isError) {      
        return data;
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};

export const GetAssets = async () => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Asset/get`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
}

export const DeleteAsset = async (assetID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Asset/delete?assetID=${assetID}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
}

export const uploadAttachment = async (assetID, file) => {
  try {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('EntityType', 'Asset');
    formData.append('EntityId', assetID);
    formData.append('MediaType', 'Attachment');
    formData.append('FileName', file.name);

    const response = await fetch(`${dev_baseUrl}/Media/upload`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    // Check if the response is not OK, then throw an error with the response message from the API.
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to upload attachment');
    }

    // Parse the JSON from the response
    const data = await response.json();
    // console.log('Response:', data);
    return data;
  } catch (error) {
    console.error('Error uploading attachment:', error);
    return {
      isError: true,
      message: error.message || 'Failed to upload attachment'
    };
  }
};

export const getAttachments = async (assetID) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Media/getmedia/Attachment/Asset/${assetID}/0`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        
      
      if (response.ok && !data.isError) {               
        return data;        
      } else {
        console.error('Server error:', data);
        return { isError: true, message: data.message || 'An error occurred. Please try again later.' };
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { isError: true, message: 'Access token is missing.' };
  }
};
